const styles = {
  Finished: "bg-emerald-100 text-emerald-700",
  Pending: "bg-amber-100 text-amber-700",
  Open: "bg-rose-100 text-rose-700",
  Recalculated: "bg-blue/20 text-blue/70",
  Refunded: "bg-red-100 text-red-700",
  Rejected: "bg-red-100 text-red-700",
};
export default function StatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-[11px] font-semibold ${styles[status] || "bg-slate-100 text-slate-700"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}
